<template>
  <div class="inner-box">
    <el-form>
      <div class="content-name">
        <h2 class="dp-ib">샘플 화면</h2>
      </div>

    </el-form>
    <el-divider></el-divider>
    <el-form size="mini">
        <el-row>
            <el-col :span="10">
                <el-form-item label="자동완성키워드">
                    <el-col :span="8">
                        <el-auto-input v-model="keyword" :list="targetList" :multiple="false" ></el-auto-input>
                    </el-col>
                    <el-col :span="2">
                        <el-button type="primary" icon="el-icon-search" @click="getKeyword">
                            확인
                        </el-button>
                    </el-col>
                </el-form-item>
            </el-col>
        </el-row>
        
    </el-form>
    <el-divider></el-divider>
    <el-form size="mini">
        <el-form-item label="버튼 샘플">
            <el-button type="primary" icon="el-icon-search">검색</el-button>
            <el-button type="primary" icon="el-icon-document-add">저장</el-button>
            <el-button type="info" icon="el-icon-close">취소</el-button>
            <el-button type="danger" icon="el-icon-delete">삭제</el-button>
            <el-button type="warning" icon="el-icon-document-copy">순서저장</el-button>
            <el-button type="primary" icon="el-icon-plus">입고추가</el-button>
            <el-button type="danger" icon="el-icon-delete-solid">입고삭제</el-button>
            <el-button type="primary" icon="el-icon-check">환입저장</el-button>
            <el-button type="info" icon="el-icon-close">환입취소</el-button>
            <el-button type="primary" icon="el-icon-plus"></el-button>
            <el-button type="danger" icon="el-icon-minus"></el-button>
        </el-form-item>
        <el-form-item>
            <el-link href="https://element.eleme.io/#/en-US/component/icon" target="_blank" style="color:red;">아이콘 참조링크</el-link>
        </el-form-item>
    </el-form>
    <el-divider></el-divider>
    <div class="ck-editor-sample">
        <el-form>
            <el-form-item>
                <el-button type="primary" @click="onEditorChange($refs.editor)">{{isReadOnly ? 'ReadOnly해제': 'ReadOnly설정'}}</el-button>
            </el-form-item>
        </el-form>
        <ckeditor
            id="editor"
            ref="editor"
            :editor="editor"
            v-model="editorData"
            :config="editorConfig"
            @ready="onEditorReady"
            @focus="onEditorFocus"
            @blur="onEditorBlur"
            @input="onEditorInput"
            @destroy="onEditorDestroy"
        ></ckeditor>
    </div>
    
    <div class="grid-tbl-box">
        <ag-grid-vue 
            ref="grid"
            style="width: 700px; height: 300px;"
            class="ag-theme-alpine"
            :columnDefs="columnDefs"
            :defaultColDef="defaultColDef"
            :rowData="rowData"
            :context="context"
            :grid-options="gridOptions"
            @cell-value-changed="onCellValueChanged"
            :framework-components="frameworkComponents"
            @cell-editing-started="onCellEditingStarted"
            @cell-editing-stopped="onCellEditingStopped"
            :enableRangeSelection="true"
            :stopEditingWhenCellsLoseFocus="true"
            :groupSelectsChildren="true"
            :rowSelection="rowSelection"
            :suppressRowClickSelection="true"
            :isRowSelectable="isRowSelectable"
            @grid-ready="onReady"
            editType="fullRow"/>
            <!--
            :columnDefs="columnDefs"
            @grid-ready="onGridReady"
            :defaultColDef="defaultColDef"
            :rowSelection="rowSelection"
            :suppressRowClickSelection="true"
            :rowData="rowData" -->
    </div>
    <el-button @click="sampleSave">확인</el-button>
    <el-divider></el-divider>
    <div class="el-table-tree">
        <el-table
            size="mini"
            border
            default-expand-all
            :data="tableData"
            row-key="id"
            style="width: 100%">
            <el-table-column
            type="index"
            :index="indexMethod">
            </el-table-column>
            <el-table-column
            prop="name"
            label="작성자"
            width="180">
            </el-table-column>
            <el-table-column
            prop="contents"
            label="내용">
            </el-table-column>
            <el-table-column
            prop="date"
            label="작성일"
            sortable
            :formatter="dateFormatter"
            width="180">
            </el-table-column>
            <el-table-column
                label="삭제"
                width="100">
                <template slot-scope="scope">
                    <el-button
                    size="mini"
                    type="danger"
                    @click="deleted(scope.$index, scope.row)">삭제</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <el-divider></el-divider>

    <div class="el-tab-pane survey">
        <el-tabs :tab-position="tabPosition" style="height: 600px; overflow-y: auto;">
            <el-tab-pane label="설문1">
                <tempate>
                    <el-row>
                        <el-col>
                            <h3>
                            질문을 길게 한번 해봅시다.질문을 길게 한번 해봅시다.질문을 길게 한번 해봅시다. <br/>
                            질문을 길게 한번 해봅시다.질문을 길게 한번 해봅시다. <br/>
                            질문을 길게 한번 해봅시다.질문을 길게 한번 해봅시다.   
                            </h3>
                        </el-col>
                    </el-row>
                </tempate>
                <el-divider></el-divider>
                <el-row>
                    <el-col>
                        <el-radio-group v-model="radio">
                            <el-radio :label="1">아주 좋다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="2">좋다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="3">보통</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="4">아니다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="5">아주 아니다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="6">기타</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="설문2">
                <el-descriptions title="설문 질의 응답 2번째" :column="1" border>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-user"></i>
                            질문
                        </template>
                        2번째 질문도 길게 한번 작성해봅니다. <br/>
                        2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다. <br/>
                        2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다. <br/>
                        2번째 질문도 길게 한번 작성해봅니다. <br/>
                        2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.2번째 질문도 길게 한번 작성해봅니다.
                    </el-descriptions-item>
                    <el-descriptions-item label="답변">
                        <el-radio-group v-model="radio">
                            <el-radio :label="1">아주 좋다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="2">좋다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="3">보통</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="4">아니다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="5">아주 아니다</el-radio>
                            <el-divider direction="vertical"></el-divider>
                            <el-radio :label="6">기타</el-radio>
                            <el-divider direction="vertical"></el-divider>
                        </el-radio-group>
                    </el-descriptions-item>
                </el-descriptions>
            </el-tab-pane>
            <el-tab-pane label="설문3">
                <el-descriptions :column="1" direction="vertical" border>
                    <el-descriptions-item label="질문">
                        <el-row>
                            <el-col>
                                3번째 질문은 짧게<br/>
                            </el-col>
                        </el-row>
                    </el-descriptions-item>
                </el-descriptions>
                <el-divider></el-divider>
                <el-row>
                    <el-col>
                        <el-radio-group v-model="radio" size="mini">
                            <el-radio :label="1">답변도 길게길게답변도 길게길게답변도 길게길게답변도 길게길게</el-radio>
                            <el-divider></el-divider>
                            <el-radio :label="2">좋다</el-radio>
                            <el-divider></el-divider>
                            <el-radio :label="3">보통</el-radio>
                            <el-divider></el-divider>
                            <el-radio :label="4">아니다</el-radio>
                            <el-divider></el-divider>
                            <el-radio :label="5">아주 아니다</el-radio>
                            <el-divider></el-divider>
                            <el-radio :label="6">기타</el-radio>
                            <el-divider></el-divider>
                        </el-radio-group>
                    </el-col>
                </el-row>
            </el-tab-pane>
            <el-tab-pane label="설문4">
            </el-tab-pane>
            <el-tab-pane label="설문5">
            </el-tab-pane>
        </el-tabs>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import ElAutoInput from '@/components/elementUI/el-auto-input.js';


/**
 * * [CK-Editor5 Documentation URL](https://ckeditor.com/docs/ckeditor5/latest/installation/frameworks/vuejs-v2.html)
 * Sample code for CKEditor 5.
 */
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import ImageUploadAdapter from '@/libs/ckeditor/ImageUploadAdapter.js';
// import { ImageToolbar } from '@ckeditor/ckeditor5-image';
// import { CKEditor } from '@ckeditor/ckeditor5-vue2';

/**
 * * mixins
 */
import slip from '@/mixin/slip';
import common from '@/mixin/common';


/**
 * * grid components
 */
import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer';
import SelectCellRenderer from '@/components/agGrid/select-cell-renderer';
import SelectCellRendererSecondary from '@/components/agGrid/select-cell-renderer-secondary';
import dropDown from '@/components/agGrid/dropDown.js';

export default {
    name:'Sample',
    mixins: [slip, common],
    components:{ AgGridVue, ElAutoInput},
    data(){
        return {
            keyword: undefined,
            targetList: [{value: '홍길동'}, {value: '홍길순'}, {value: 'table'}, {value: 'input'}, {value: 'test'}],
            /**
             * Classic CKEditor
             */
            editor: ClassicEditor,
            editorData: '<p> 에디터에 데이터를 입력하세요. </p>',
            editorConfig: {
                language: 'en',
                extraPlugins: [ ImageUploadAdapter ]
            },
            isReadOnly: false,
            // AG-GRID OPTION [START]
            frameworkComponents: {
                select: SelectCellRendererSecondary,
                dropDown: dropDown,
                checkBox: CheckboxCellRenderer,
            },
            rowSelection: null,
            context: {
                // context is used as a global variable
                editorUpdateMethods: {},
                editorRefs: {},
                getRefData: this.getRefData,
                //체크박스 전체 체크에 필요한 함수
                // rowData: this.getRowsData, //현 그리드에 그려지는 데이터 가져오는 함수()
                headerAllCheckEvent: this.allCheckEvnet,//전체 체크 데이터로 데이터 셋 함수
            },
            gridOptions: {
                enableColResize: true,
                enableFilter: true,
                animateRows: false,
                enableSorting: true,
            },
            
            rowData: [
                { chk: 'Y', country: 'A', areaType: 'state1', city: 'st1 A city', qty: 0, qty2: 0 },
                { chk: 'Y', country: 'B', areaType: 'province3', city: 'pro3 B city', qty: 0, qty2: 0  },
                { chk: 'N', country: 'C', areaType: 'province4', city: 'pro4 B city', qty: 0, qty2: 0  },
            ],
            defaultColDef: { 
                flex: 1, 
                editable: true,
                filter: true, 
            },
            tableData: [{
                id: 1,
                date: '2023-04-18 08:00',
                name: '아무개1',
                contents: `콘텐츠 내용 1`,
            },{
                id: 2,
                date: '2023-04-18 09:00',
                name: '아무개2',
                contents: `콘텐츠 내용 2`,
                children: [{
                    id: 21,
                    date: '2023-04-18 09:10',
                    name: '홍길동2-1',
                    contents: `콘텐츠 내용 댓글 2-1`,
                }, {
                    id: 22,
                    date: '2023-04-18 09:20',
                    name: '홍길동2-2',
                    contents: `콘텐츠 내용 댓글 2-2`,
                }]
            },{
                id: 3,
                date: '2023-04-18 07:00',
                name: '아무개3',
                contents: `콘텐츠 내용 3`,
            },],
            tabPosition: 'left',
            radio: 1,
            isRowSelectable: null,
            gridApi: null,
            columnApi: null,
        }
    },
    computed: {
    },
    created() {
        const _this = this;
        this.columnDefs = [
                {
                    field:'chk', 
                    headerComponent: `checkBox`,
                    headerComponentParams: (params) => {
                        return params;
                    },
                    cellRenderer: 'checkBox',
                    cellRendererParams(params) {
                        return {
                            trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                          , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                          , disable: params.data.country === 'C'
                        }
                    },
                    editable : false,
                },
                {
                    field: 'country',
                    cellEditor: 'select',
                    cellEditorParams: { 
                        values: ['A', 'B'], focusOnEditStart: true 
                    },
                },
                {
                    headerName: 'State / Province',
                    field: 'areaType',
                    cellEditor: 'select',
                    // cellEditorParams are read whenever editing starts
                    cellEditorParams: ({ data }) => 
                    this.getDropDownEditorParams('country', data, this.getRefData),
                },
                {
                    field: 'city',
                    cellEditor: 'select',
                    cellEditorParams: ({ data }) => 
                        this.getDropDownEditorParams('areaType', data, this.getRefData),
                },
                {
                    headerName:'대수',
                    field:'qty', 
                    width:90,
                    editable : true,
                    cellStyle:{textAlign: 'center', backgroundColor: '#fff8f7'},
                    valueFormatter: (params) => {
                        return this.numberFormat(params.value);
                    }
                },
                {
                    headerName:'대수2',
                    field:'qty2', 
                    width:90,
                    editable : false,
                    cellStyle:{textAlign: 'center', backgroundColor: '#fff8f7'},
                    valueFormatter: (params) => {
                        return this.numberFormat(params.value);
                    }
                },
            ];
            
            this.rowSelection = 'multiple';
            this.isRowSelectable = (rowNode) => {
                return rowNode.data ? rowNode.data.chk : false;
            };
    },

    mounted() {
        
    },
    methods: {
        onReady() {
            this.gridApi = this.gridOptions.api;
            this.columnApi = this.gridOptions.columnApi;
        },
        allCheckEvnet(field, checked) {
            return this.rowData = this.rowData.map(x => {
                if(x.country !== 'C') {
                    x[field] = checked ? 'Y' : 'N';
                }
                return x;
            })
        },
        sampleSave() {
            console.log('test', this.gridOptions.api, this.rowData);
        },
        numberFormat(param) {
            return this.getNumberFormat(param);
        },
        onCellValueChanged(params) {
            
        },
        onCellEditingStarted(event) {
            console.log("onCellEditingStarted", event)
        },
        onCellEditingStopped(event) {
            console.log("onCellEditingStopped", event)
        },
        getKeyword() {
            if(this.keyword.length > 0) {
                this.$swal({ type: 'success', text: `검색 완료 키워드는 "${this.keyword}" 입니다.` })
            } else {
                this.$swal({ type: 'warning', text: `검색 키워드가 없습니다.` })
            }
        },
        onEditorChange(eventInfo) {
            this.isReadOnly = !this.isReadOnly;
            if(this.isReadOnly) {   //read only
                eventInfo.$_instance.enableReadOnlyMode("editor",this.isReadOnly)
            } else {    //read only 해제
                eventInfo.$_instance.disableReadOnlyMode("editor", this.isReadOnly)
            }
        },
        onEditorReady(eventInfo) {
            eventInfo.editing.view.change((writer)=> {
                writer.setStyle("height", "200px", eventInfo.editing.view.document.getRoot())
            });
            // console.log('onEditorReady', eventInfo);
        },
        onEditorFocus(eventInfo, data ) {
            // console.log('onEditorFocus', eventInfo, data);
        },
        onEditorBlur(eventInfo, data ) {
            // console.log('onEditorBlur', eventInfo, data);
        },
        onEditorInput(eventInfo, batch) {
            // console.log('onEditorInput', eventInfo, batch);
            //Corresponds to the change:data editor event. See the v-model directive to learn more.
        },
        onEditorDestroy(eventInfo) {
            // console.log('onEditorDestroy', eventInfo);
        },
        getDropDownEditorParams(parentColumn, data, getRefData) {
            const parentCellValue = data[parentColumn];
            return {
                // the editor is provided with initial options for the select editor
                values: getRefData(parentCellValue),
                // and parent column name / colId
                cascadeFrom: parentColumn,
            };
        },
        getRefData(key) {
            // I used flat reference data
            // for a more straightforward generalisation of the custom select editor
            // Please note the same editor is used across all columns
            let refData = {
                A: ['state1', 'state2', 'state3'],
                B: ['province1', 'province2', 'province3'],

                state1: ['st1 A city', 'st1 B city', 'st1 C city'],
                state2: ['st2 A city', 'st2 B city', 'st2 C city'],
                state3: ['st3 A city', 'st3 B city', 'st3 C city'],

                province1: ['pro1 A city', 'pro1 B city', 'pro1 C city'],
                province2: ['pro2 A city', 'pro2 B city', 'pro2 C city'],
                province3: ['pro3 A city', 'pro3 B city', 'pro3 C city'],
            };

            return refData[key];
        },
        getRowsData() {
            return this.rowData;
        },
        indexMethod(index) {
            return ++index;
        },
        dateFormatter(row, column) {
            return this.$moment(row.date).format('yyyy-MM-DD HH:mm:ss')
        },
        deleted(index, row) {
            console.log(index, row)
        }
    }
}

</script>